export default __webpack_public_path__ + "static/media/icon-warning.2d798549.svg";